/**
 * Whether two inclusive day ranges ("YYYY-MM-DD", both bounds inclusive) share at least one day.
 * Plain string comparison is enough: the "YYYY-MM-DD" shape sorts lexicographically the same as
 * chronologically, so no `Date` parsing (and no timezone) is involved. Shared by the Leave Sheet's
 * per-day "does this leave cover today" check and the Leave Overview's per-request "does this leave
 * fall in the HR period" check (see `leave-sheet-ledger.ts` / `leave-overview.service.ts`).
 */
export const rangesOverlap = (
  aStart: string,
  aEnd: string,
  bStart: string,
  bEnd: string
): boolean =>
  Boolean(aStart) &&
  Boolean(aEnd) &&
  Boolean(bStart) &&
  Boolean(bEnd) &&
  aStart <= bEnd &&
  aEnd >= bStart;
